/** Select value when the user enters state / province / region manually */
export const NON_US_STATE_SELECT_VALUE = '__NON_US_REGION__'

const BASE_US_STATE_NAMES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
  'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina',
  'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
]

const US_TERRITORY_AND_DC_NAMES = [
  'American Samoa',
  'District of Columbia',
  'Guam',
  'Northern Mariana Islands',
  'Puerto Rico',
  'U.S. Virgin Islands'
]

/** U.S. states plus D.C. and populated U.S. territories (for dropdowns) */
export const LISTED_STATE_AND_TERRITORY_NAMES = [...BASE_US_STATE_NAMES, ...US_TERRITORY_AND_DC_NAMES]

export const LISTED_STATE_SELECT_OPTIONS = LISTED_STATE_AND_TERRITORY_NAMES.map((name) => ({
  value: name,
  label: name
}))

export const LISTED_STATE_OPTIONS_WITH_NON_US = [
  ...LISTED_STATE_SELECT_OPTIONS,
  {
    value: NON_US_STATE_SELECT_VALUE,
    label: 'Outside U.S. (enter state / province / region)'
  }
]

export function isListedUsStateOrTerritory(value) {
  return LISTED_STATE_AND_TERRITORY_NAMES.includes(String(value || ''))
}

/** Value passed to Select: listed name, empty, or the non-U.S. sentinel */
export function toStateSelectValue(storedState) {
  const s = String(storedState || '')
  if (!s) return ''
  if (isListedUsStateOrTerritory(s)) return s
  return NON_US_STATE_SELECT_VALUE
}
